(function () {
    'use strict';

    angular
        .module('app.userManagement')
        .factory('userManagementService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getUserManagementData(params, url, loader) {
                    var url_searchUnassignUser = url;
                    return handleRequest(url_searchUnassignUser, 'POST', params, loader);
                }

                function updateUserStatus(params, loader) {
                    var url_updateUserStatus = $rootScope.apiUrl + 'admin/updateUserStatus';
                    return handleRequest(url_updateUserStatus, 'POST', params, loader);
                }

                function activeUser(user_id, loader) {
                    var url_activeUser = $rootScope.apiUrl + 'admin/activeUser?user_id=' + user_id;
                    return handleRequest(url_activeUser, 'GET', null, loader);
                }

                function deactivateUser(user_id, loader) {
                    var url_deactivateUser = $rootScope.apiUrl + 'admin/deactivateUser?user_id=' + user_id;
                    return handleRequest(url_deactivateUser, 'GET', null, loader);
                }

                function deleteUser(params, loader) {
                    var url_deleteUser = $rootScope.apiUrl + 'admin/deleteUser';
                    return handleRequest(url_deleteUser, 'POST', params, loader);
                }

                function inviteNewUser(params, loader) {
                    var url_inviteNewUser = $rootScope.apiUrl + 'admin/inviteNewUser';
                    return handleRequest(url_inviteNewUser, 'POST', params, loader);
                }

                function updateProfile(params, loader) {
                    var url = $rootScope.apiUrl + 'influencer/updateInfluencerProfile'; //'user/updateprofile';
                    return handleRequest(url, 'POST', params, loader);
                }

                service.getUserManagementData = getUserManagementData;
                service.updateUserStatus = updateUserStatus;
                service.activeUser = activeUser;
                service.deactivateUser = deactivateUser;
                service.deleteUser = deleteUser;
                service.inviteNewUser = inviteNewUser;
                service.updateProfile = updateProfile;

                return service;
            }
        ]);
})();
